import store from '@/store/store';

const FieldGroupBoilerplate = {
    computed: {
        fieldsInGroup() {
            return store.state[this.fieldNamespace].options.fieldsInGroup;
        },

        groupInline() {
            return store.state[this.fieldNamespace].options.groupInline;
        },

        groupNumbered() {
            return store.state[this.fieldNamespace].options.groupNumbered;
        },

        groupFields() {
            return store.state[this.fieldNamespace].options.group;
        },
    },

    data() {
        return {
            dataArray: [],
            fieldTypes: ['text', 'textarea'],
        };
    },

    methods: {
        loadFieldData() {
            this.mergePopulationSubmission();
            this.setFieldData();
        },

        mergePopulationSubmission() {
            let subFields = [];
            let popFields = [];

            // Do we have a submission, a population, or both?
            const hasSub = Object.keys(this.submission).length !== 0 && this.submission.constructor === Object;
            const hasPop = Object.keys(this.population).length !== 0 && this.population.constructor === Object;

            // Populations
            if (hasPop) {
                popFields = this.population.data;
                Object.values(popFields).forEach((fieldData, index) => {
                    if (fieldData) {
                        this.dataArray[index] =  fieldData;
                    }
                });
            }

            // Submissions overwrite populations
            if (hasSub) {
                subFields = this.submission.data;
                Object.values(subFields).forEach((fieldData, index) => {
                    if (fieldData) {
                        this.dataArray[index] =  fieldData;
                    }
                });
            }
        },

        setFieldData()
        {
            this.fieldData = {
                data: this.dataArray,
            };

            this.storeFieldData();
        }
    }
};

export default FieldGroupBoilerplate;
